import React from "react";
import { Button } from "semantic-ui-react";
import { PaymentType, Priceable } from "../Types";
import { Quotation } from "../../../stores/CoursePreviewStore/Types";

interface Props {
  onSubmit: (e: any) => void;
  isSubmitting?: boolean;
  isDisabled?: boolean;
  slug: string;
  paymentType: PaymentType;
  priceable: Priceable;
  activeQuote: Quotation;
}

const Action: React.FC<Props> = ({
  slug,
  activeQuote,
  paymentType,
  priceable,

  isDisabled = false,
  isSubmitting = false,
  onSubmit,
}) => {
  const buttonName = () => {
    if (!activeQuote) return "Loading...";

    if (activeQuote?.amount <= 0) return "Get Started!";

    const amount = `${activeQuote.currency}${activeQuote.formatted_amount}`;

    if (paymentType === "course" || priceable?.type === "course") {
      return `Buy Course, ${amount}`;
    }

    if (paymentType === "subscription" || priceable?.type === "pass") {
      if (slug === "lifetime" || priceable?.is_lifetime) {
        return `Secure Lifetime Access, ${amount}`;
      }

      if (slug === "community" || priceable?.is_community) {
        return `Join Community, ${amount}/month`;
      }

      return priceable?.interval === "month" || activeQuote.interval === "month"
        ? `Start Learning, ${amount}/month`
        : `Start Learning, ${amount}`;
    }

    return amount;
  };

  return (
    <Button
      id="submitBtn"
      disabled={isDisabled}
      className={`${isSubmitting ? "loading submit-btn" : "submit-btn"}`}
      type="submit"
      onClick={(e) => onSubmit(e)}
    >
      {buttonName()}
    </Button>
  );
};

export default Action;
